import {initialState} from '../state';
import {CurationInfoForPathwaysActions, CurationInfoForPathwaysActionTypes} from '../actions';

export function knowledgeBase(state = initialState.knowledgeBase, action: CurationInfoForPathwaysActions): string {
  switch (action.type) {
    case CurationInfoForPathwaysActionTypes.UPDATE_KNOWLEDGE_BASE:
      return action.payload.knowledgeBase;
    default: {
      return state;
    }
  }
}
